import * as React from "react";
function SvgRadio(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <g fill="#fff">
        <path d="M16.83 19.5a4.77 4.77 0 003.68-4.8V9.51c0-2.93-1.51-5-3.68-5.44a4.56 4.56 0 00-5.27 3.71 4.91 4.91 0 00-.07.86v6.29A4.55 4.55 0 0016 19.57a3.69 3.69 0 00.83-.07z" />
        <path d="M25 15.19a1.13 1.13 0 10-2.25 0 6.76 6.76 0 01-13.52 0A1.16 1.16 0 008.11 14 1.14 1.14 0 007 15.18a9.08 9.08 0 007.88 9v1.46h-3a1.17 1.17 0 000 2.34h8.26a1.17 1.17 0 001.08-1.26 1.2 1.2 0 00-1.08-1.08h-3v-1.41A9.08 9.08 0 0025 15.19z" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgRadio);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
